import { Navigation } from "./Navigation";

export const Menu = () => (
  <div className="sdkui:flex sdkui:h-full sdkui:w-full sdkui:min-w-0 sdkui:gap-x-0 sdkui:lg:gap-x-3">
    <Navigation />
  </div>
);
